import React from 'react';
import { CircleTopicFragment } from '@modernhealth/circles-graphql/v3';

import { CircleStylizedCard } from './CircleStylizedCard';

export const CircleTopicCard: React.FC<{
  topic: CircleTopicFragment;
}> = ({ topic }) => {
  return <CircleStylizedCard topic={topic} session={topic.sessions.edges[0]?.node} />;
};
